import { registerPlugin, type Plugin, type PluginListenerHandle } from '@capacitor/core';

export type NfcNeedSdmKeyEvent = {
  uid: string;
};

export interface INfcSunPlugin extends Plugin {
  configureSun(options: {
    /** Base URL that will be written to the NFC tag, e.g. "https://example.com/nfc" */
    baseUrl: string;
    /** Shared Key 0 (AES-128 hex). Used to authenticate and write the tag. */
    currentKey: string;
    /**
     * RentalKeyTag: probe Key 1 and install it when still factory.
     * Omit for car tags (SDMFileRead stays on Key 0).
     */
    provisionKey1?: boolean;
    /** Shown on the system NFC sheet while waiting for a tag. */
    alertMessage?: string;
    /** Shown on the system NFC sheet after a successful write. */
    successMessage?: string;
  }): Promise<{
    success: boolean;
    uid: string;
  }>;
  addListener(
    eventName: 'needSdmKey',
    listenerFunc: (event: NfcNeedSdmKeyEvent) => void,
  ): Promise<PluginListenerHandle>;
  /** Key 1 from the backend (get-or-create). Used only when slot 1 is still factory. */
  continueWithSdmKey(options: { sdmKey: string }): Promise<void>;
  abortSun(options?: { message?: string }): Promise<void>;
}

const NfcSunPlugin = registerPlugin<INfcSunPlugin>('NfcSun');
export default NfcSunPlugin;
